import {hasActiveBoardSeatForProperty} from "@/src/modules/core/lib/board-seat";
import type {Me} from "@/src/modules/core/types";

import {isResidentBoardModulePath} from "./resident-board-nav-route-keys";

export {isResidentBoardModulePath} from "./resident-board-nav-route-keys";

export function getResidentNavigationPathBeforeContextChange(args: {
  pathname: string;
  me: Me;
  nextPropertyId: number | string;
}): string | null {
  const {pathname, me, nextPropertyId} = args;
  if (!me.isResident) return null;
  if (!isResidentBoardModulePath(pathname)) return null;
  if (hasActiveBoardSeatForProperty(me, nextPropertyId)) return null;
  return "/home";
}
